import axios from "@/axios";

export default {
  namespaced: true,
  state: {
    promocode: '',
    promocodeApplied: false,
    promocodeData: null,
    discountAmount: 0,
    loading: false,
    error: '',
    success: '',
  },
  mutations: {
    SET_PROMOCODE(state, code) {
      state.promocode = code;
    },
    SET_PROMOCODE_APPLIED(state, applied) {
      state.promocodeApplied = applied;
    },
    SET_PROMOCODE_DATA(state, data) {
      state.promocodeData = data;
    },
    SET_DISCOUNT_AMOUNT(state, amount) {
      state.discountAmount = amount;
    },
    SET_LOADING(state, loading) {
      state.loading = loading;
    },
    SET_ERROR(state, error) {
      state.error = error;
    },
    SET_SUCCESS(state, success) {
      state.success = success;
    },
    RESET_PROMOCODE(state) {
      state.promocode = '';
      state.promocodeApplied = false;
      state.promocodeData = null;
      state.discountAmount = 0;
      state.error = '';
      state.success = '';
    },
  },
  actions: {
    async applyPromocode({ commit, state }) {
      if (!state.promocode) return;

      commit('SET_LOADING', true);
      commit('SET_ERROR', '');
      commit('SET_SUCCESS', '');

      try {
        const response = await axios.get('promocode/check', {
          params: {
            code: state.promocode
          }
        });

        if (response.data.status === 'OK') {
          const discount = parseFloat(response.data.payload.calculated_discount);
          
          commit('SET_PROMOCODE_DATA', response.data.payload);
          commit('SET_DISCOUNT_AMOUNT', discount);
          commit('SET_PROMOCODE_APPLIED', true);
          commit('SET_SUCCESS', 'Promo code applied successfully!');

          setTimeout(() => {
            commit('SET_SUCCESS', '');
          }, 3000);

          return { success: true, discount };
        }
      } catch (error) {
        const errorMessage = error.response?.data?.message || 'Invalid promo code';
        commit('SET_ERROR', errorMessage);
        
        setTimeout(() => {
          commit('SET_ERROR', '');
        }, 3000);

        return { success: false, error: errorMessage };
      } finally {
        commit('SET_LOADING', false);
      }
    },
    
    setPromocode({ commit }, code) {
      commit('SET_PROMOCODE', code);
    },

    resetPromocode({ commit }) {
      commit('RESET_PROMOCODE');
    },
  },
  getters: {
    promocode: state => state.promocode,
    promocodeApplied: state => state.promocodeApplied,
    promocodeData: state => state.promocodeData,
    discountAmount: state => state.discountAmount,
    loading: state => state.loading,
    error: state => state.error,
    success: state => state.success,
    hasDiscount: state => state.discountAmount > 0,
  }
};
